var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sequential-entrance',{attrs:{"fromBottom":""}},[_c('v-card',{staticClass:"video-card-1",staticStyle:{"padding":"0px","align":"width: 100%"}},[_c('youtube',{staticClass:"video-card-1",attrs:{"video-id":_vm.videoId,"width":"1920","height":"1100","margin":"0","padding":"0","player-vars":_vm.playerVars},on:{"playing":_vm.playing}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }